import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { space, fontWeight, fontSize } from 'styled-system';
import withBreadcrumbs from 'react-router-breadcrumbs-hoc';
import theme from 'styled-theming';

const breadcrumbColor = theme('mode', {
  light: (props) => props.theme.colors.mediumPurple,
  dark: (props) => props.theme.colors.aqua,
});

const spacerColor = theme('mode', {
  light: (props) => props.theme.colors.midGrey,
  dark: (props) => props.theme.colors.midLightGrey,
});

const disabledColor = theme('mode', {
  light: (props) => props.theme.colors.midGrey,
  dark: (props) => props.theme.colors.midLightGrey,
});

const Spacer = styled.span`
  ${space}
  ${fontWeight}
  ${fontSize}
  color: ${spacerColor};
`;

const BreadcrumbItem = styled(NavLink)`
  ${fontWeight}
  ${fontSize}
  color: ${breadcrumbColor};
`;

const BreadcrumbDisabled = styled.span`
  ${fontWeight}
  ${fontSize}
  color: ${disabledColor};
`;

const routes = [
  { path: '/', breadcrumb: 'Conversation Orchestrator' },
  { path: '/recommended-actions', breadcrumb: 'Bots' },
  { path: '/knowledge-base', breadcrumb: 'Knowledge Bases' },
  { path: '/intent-content-policies', breadcrumb: 'Manage Policies' },
  { path: '/policy-logs', breadcrumb: 'Policy Logs' },
  { path: '/custom-context', breadcrumb: 'Custom Context' },
  { path: '/sde-context', breadcrumb: 'SDE Context' },
  { path: '/conversation-context', breadcrumb: 'Conversational Context' },
  { path: '/ask-maven', breadcrumb: 'APIs' },
  { path: '/engagement-controller', breadcrumb: 'Manage Rules' },
  { path: '/settings', breadcrumb: 'API Authorization' },
];

function Breadcrumbs({ breadcrumbs }) {
  return (
    <Box mb={4} data-testid="breadcrumbs">
      {breadcrumbs.map(({ match, breadcrumb }, index) => {
        const isNotLast = index + 1 !== breadcrumbs.length;
        if (isNotLast) {
          return (
            <Fragment key={breadcrumb.key}>
              <BreadcrumbItem to={match.url} fontWeight={300} fontSize={1}>
                {breadcrumb}
              </BreadcrumbItem>
              <Spacer px={2} fontWeight={300} fontSize={1}>
                /
              </Spacer>
            </Fragment>
          );
        }
        if (breadcrumbs.length > 0) {
          return (
            <BreadcrumbDisabled key={breadcrumb.key} fontWeight={300} fontSize={1}>
              {breadcrumb}
            </BreadcrumbDisabled>
          );
        }
        return null;
      })}
    </Box>
  );
}

Breadcrumbs.defaultProps = {
  breadcrumbs: [],
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
};

export default withBreadcrumbs(routes)(Breadcrumbs);
